<template>
  <b-container class="pt-2 pb-2 border-info border">
    <b-row>
      <b-col><h5>Labels</h5></b-col>
    </b-row>
    <div data-test-path="branding-links">
    <b-row v-for="labelInfo in links" :key="labelInfo.fileId">
       <b-button variant="link" :disabled="disabledLinks" @click="schedulePDF(labelInfo)"
                 :data-test-path="labelInfo.__label.substring(0,10)">
         {{ labelInfo.__label }}
        </b-button>
    </b-row>
    </div>

  </b-container>
</template>

<script>
import MixinFormComponentConfig from "@/server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig";
import WCLProduct from "@/server/com/silkplm/model/plm/WCLProduct";
import BrandingProduct from "@/server/com/silkplm/model/plm/BrandingProduct";

export default {
  name: "WclList",
  created() {
  },

  async mounted() {
    this.parentForm.onLoaded(async () => {
      /**
       * @type {WCLProduct}
       */
      let instance = this.parentForm.originalSource;
      await this.refreshInstance(instance);
    });
  },

  methods: {
    setEditorMode(val) {
    },
    setReadOnly(readOnly) {
      this.readOnly = this.mixinConfig.readOnly || readOnly
    },

    async schedulePDF(labelInfo){
      await Rpc.plm.WclTemplates.schedulePDF(labelInfo);
    },

    async refreshInstance(instance) {
      let wclProductClazz = await WCLProduct.getRemoteClass();
      let brandingProductClazz = await BrandingProduct.getRemoteClass();
      if (this.parentForm.formConfig.formClassLong === wclProductClazz) {
        if (instance?.id) {
          this.links = await Rpc.plm.WclTemplates.loadLabelsShort(instance.id).lock();
        } else {
          this.links = [];
        }
      } else if (this.parentForm.formConfig.formClassLong === brandingProductClazz) {
        let selectedBrandingDetailsId = this.parentForm.fields.brandingDetailsId?.value;
        this.links = await Rpc.plm.WclTemplates.loadLabelsShortForBrandingProduct(instance, selectedBrandingDetailsId).lock();
      }
      if (this.links) {
        for (let link of this.links) {
          if (link.fileName.endsWith(".indd")) {
            link.__label = link.fileName + " - Generate PDF"
          } else {
            link.__label = link.fileName;
          }
        }
      }
    },
  },
  data: function () {
    return {
      /**
       * @type{LabelInfo[]}
       */
      links: [],
      permission: true,
      readOnly: true,
      downloadingPDF: false,
      pdfError: false,
      currentFileName: "",
      disabledLinks: false,
    }
  },

  watch: {
    "parentForm.fields.brandingDetailsId.value": async function (val) {
      let instance = this.parentForm.originalSource;
      await this.refreshInstance(instance);
    },
  },

  props: {
    mixinConfig: {type: MixinFormComponentConfig},

    /** @type{FormsListContext|*}*/
    context: {default: null},

    /** @type{string|*} EDIT or NEW*/
    mode: {default: null},
    editorMode: {default: false},

    /** @type{FormModel|*}*/
    parentForm: {default: null},

    /** @type{FormModel|*}*/
    masterFormModel: {default: null},
  }
}
</script>